window.lib = window.lib || {};
window.images = window.images || {};
window.ss = window.ss || {};
(function (lib, img, ss, cjs, an) {

var p; // shortcut to reference prototypes

lib.ssMetadata = [];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



(lib.BackButtonIcon = function() {
	this.initialize(img.SmartphoneAssets_BackButtonIcon);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,22,26);


(lib.BackButtonSmallIcon = function() {
	this.initialize(img.SmartphoneAssets_BackButtonSmallIcon);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,19,22);


(lib.BG = function() {
	this.initialize(img.SmartphoneAssets_BG);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,398,817);


(lib.BGB1 = function() {
	this.initialize(img.SmartphoneAssets_BGB1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,398,817);


(lib.BGDarkGrey = function() {
	this.initialize(img.SmartphoneAssets_BGDarkGrey);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,398,817);


(lib.ChatConfirmButtonDisabled = function() {
	this.initialize(img.SmartphoneAssets_ChatConfirmButtonDisabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,39,38);


(lib.ChatConfirmButtonUp = function() {
	this.initialize(img.SmartphoneAssets_ChatConfirmButtonUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,39,38);


(lib.ChatIcon = function() {
	this.initialize(img.SmartphoneAssets_ChatIcon);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,82,82);


(lib.ChatNPCBalloon2 = function() {
	this.initialize(img.SmartphoneAssets_ChatNPCBalloon2);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,352,61);


(lib.ChatOfflineIndicator = function() {
	this.initialize(img.SmartphoneAssets_ChatOfflineIndicator);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,21,21);


(lib.ChatOnlineIndicator = function() {
	this.initialize(img.SmartphoneAssets_ChatOnlineIndicator);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,21,21);


(lib.ChatPlayerBalloonBG = function() {
	this.initialize(img.SmartphoneAssets_ChatPlayerBalloonBG);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,352,65);


(lib.ChatReplyOptionButtonDisabled = function() {
	this.initialize(img.SmartphoneAssets_ChatReplyOptionButtonDisabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,366,42);


(lib.ChatReplyOptionButtonHi = function() {
	this.initialize(img.SmartphoneAssets_ChatReplyOptionButtonHi);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,366,42);


(lib.ChatReplyOptionButtonUp = function() {
	this.initialize(img.SmartphoneAssets_ChatReplyOptionButtonUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,366,42);


(lib.ChatReplyOptionsPieletje = function() {
	this.initialize(img.SmartphoneAssets_ChatReplyOptionsPieletje);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,30,14);


(lib.ChatReplyPreviewFieldBG = function() {
	this.initialize(img.SmartphoneAssets_ChatReplyPreviewFieldBG);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,348,79);


(lib.ChoiceButtonDisabled = function() {
	this.initialize(img.SmartphoneAssets_ChoiceButtonDisabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,335,116);


(lib.ChoiceButtonHi = function() {
	this.initialize(img.SmartphoneAssets_ChoiceButtonHi);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,335,116);


(lib.ChoiceButtonUp = function() {
	this.initialize(img.SmartphoneAssets_ChoiceButtonUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,335,116);


(lib.ChoiceIndicator = function() {
	this.initialize(img.SmartphoneAssets_ChoiceIndicator);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,2,59);


(lib.CloseButtonIcon = function() {
	this.initialize(img.SmartphoneAssets_CloseButtonIcon);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,19,19);


(lib.ContactsIcon = function() {
	this.initialize(img.SmartphoneAssets_ContactsIcon);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,24,23);


(lib.DraftBG = function() {
	this.initialize(img.SmartphoneAssets_DraftBG);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,57,63);


(lib.DraftsIcon = function() {
	this.initialize(img.SmartphoneAssets_DraftsIcon);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,26,25);


(lib.DropdownIcon = function() {
	this.initialize(img.SmartphoneAssets_DropdownIcon);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,21,10);


(lib.EditIconDisabled = function() {
	this.initialize(img.SmartphoneAssets_EditIconDisabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,22,6);


(lib.EditIconUp = function() {
	this.initialize(img.SmartphoneAssets_EditIconUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,22,6);


(lib.EmailDraftInputButtonBackground = function() {
	this.initialize(img.SmartphoneAssets_EmailDraftInputButtonBackground);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,324,50);


(lib.EmailReceivedBackground = function() {
	this.initialize(img.SmartphoneAssets_EmailReceivedBackground);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,386,343);


(lib.EmptyThumb = function() {
	this.initialize(img.SmartphoneAssets_EmptyThumb);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,66,66);


(lib.EmptyThumbBig = function() {
	this.initialize(img.SmartphoneAssets_EmptyThumbBig);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,80,80);


(lib.GroupChatNPCBalloon2 = function() {
	this.initialize(img.SmartphoneAssets_GroupChatNPCBalloon2);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,352,101);


(lib.InboxIcon = function() {
	this.initialize(img.SmartphoneAssets_InboxIcon);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,25,24);


(lib.MailIcon = function() {
	this.initialize(img.SmartphoneAssets_MailIcon);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,82,82);


(lib.ModalButtonBG = function() {
	this.initialize(img.SmartphoneAssets_ModalButtonBG);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,367,52);


(lib.ModalButtonDown = function() {
	this.initialize(img.SmartphoneAssets_ModalButtonDown);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,367,51);


(lib.NewIndicatorLarge = function() {
	this.initialize(img.SmartphoneAssets_NewIndicatorLarge);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,28,28);


(lib.OfflineIndicator = function() {
	this.initialize(img.SmartphoneAssets_OfflineIndicator);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,21,21);


(lib.OnlineIndicator = function() {
	this.initialize(img.SmartphoneAssets_OnlineIndicator);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,21,21);


(lib.PhoneBG = function() {
	this.initialize(img.SmartphoneAssets_PhoneBG);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,477,919);


(lib.PhoneBG_dummy = function() {
	this.initialize(img.SmartphoneAssets_PhoneBG_dummy);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,398,817);


(lib.RedPill = function() {
	this.initialize(img.SmartphoneAssets_RedPill);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,39,28);


(lib.ReplyIcon = function() {
	this.initialize(img.SmartphoneAssets_ReplyIcon);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,25,30);


(lib.SendButtonDisabled = function() {
	this.initialize(img.SmartphoneAssets_SendButtonDisabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,47,47);


(lib.SendButtonUp = function() {
	this.initialize(img.SmartphoneAssets_SendButtonUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,47,47);


(lib.SentIcon = function() {
	this.initialize(img.SmartphoneAssets_SentIcon);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,28,28);


(lib.SmartphoneCloseButton = function() {
	this.initialize(img.SmartphoneAssets_SmartphoneCloseButton);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,77,35);


(lib.SmartphoneEmailIndicatorButtonBackground = function() {
	this.initialize(img.SmartphoneAssets_SmartphoneEmailIndicatorButtonBackground);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,226,24);


(lib.SmartphoneHand = function() {
	this.initialize(img.SmartphoneAssets_SmartphoneHand);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,620,500);


(lib.VinkjeIcon = function() {
	this.initialize(img.SmartphoneAssets_VinkjeIcon);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,22,16);


(lib.WhiteBar = function() {
	this.initialize(img.SmartphoneAssets_WhiteBar);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,157,19);// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.EmailReceivedItemBackground = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.EmailReceivedBackground();
	this.instance.setTransform(5,3,0.9766,0.9913);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EmailReceivedItemBackground, new cjs.Rectangle(5,3,377,340), null);


(lib.SmartphoneScreenDimensions = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.instance = new lib.BG();
	this.instance.setTransform(-199,-409);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SmartphoneScreenDimensions, new cjs.Rectangle(-199,-409,398,817), null);


(lib.SmartphoneHand_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.instance = new lib.SmartphoneHand();
	this.instance.setTransform(0,0,0.85,0.85);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SmartphoneHand_1, new cjs.Rectangle(0,0,527,425), null);


(lib.SmartphoneFrame = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.instance = new lib.PhoneBG();
	this.instance.setTransform(-239,-460);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SmartphoneFrame, new cjs.Rectangle(-239,-460,477,919), null);


(lib.SmartphoneBrandedScreenDimensions = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.instance = new lib.BGB1();
	this.instance.setTransform(-198,-408);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SmartphoneBrandedScreenDimensions, new cjs.Rectangle(-198,-408,398,817), null);


(lib.RoundSendButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {up:0,over:1,down:2,disabled:3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.instance = new lib.ChatConfirmButtonUp();
	this.instance.setTransform(-20,-19);

	this.instance_1 = new lib.ChatConfirmButtonDisabled();
	this.instance_1.setTransform(-20,-19);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},3).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-20,-19,39,38);


(lib.ChatScrollPaneMask = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FF3366").s().p("EgXmA5KQinAAh2h6Qh3h7AAisMAAAhryMA71AAAMAAABwkQhzBvigAAg");
	this.shape.setTransform(191.5,365.775);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ChatScrollPaneMask, new cjs.Rectangle(0,0,383,731.6), null);


(lib.ChatPlayerMessage = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// textField
	this.contentTextField = new cjs.Text("[This text should fill the whole row..................]", "15px 'Open Sans'");
	this.contentTextField.name = "contentTextField";
	this.contentTextField.lineHeight = 20;
	this.contentTextField.lineWidth = 320;
	this.contentTextField.parent = this;
	this.contentTextField.setTransform(44.5,16.8);
ranj.TextOffsetFixer.fix(this.contentTextField);

	this.timeline.addTween(cjs.Tween.get(this.contentTextField).wait(1));

	// bg
	this.instance = new lib.ChatPlayerBalloonBG();
	this.instance.setTransform(26,0);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ChatPlayerMessage, new cjs.Rectangle(-1,-408.5,398,817), null);


(lib.ChatOptionButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("[Option]", "15px 'Open Sans'", "#EBEAEA");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 22;
	this.disabledLabelTextField.lineWidth = 337;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(0,-8.7);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("[Option]", "15px 'Open Sans'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 22;
	this.downLabelTextField.lineWidth = 337;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(0,-8.7);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("[Option]", "15px 'Open Sans'");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 22;
	this.overLabelTextField.lineWidth = 337;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(0,-8.7);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("[Option]", "15px 'Open Sans'");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 22;
	this.upLabelTextField.lineWidth = 337;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(0,-8.7);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Layer_2
	this.instance = new lib.ChatReplyOptionButtonUp();
	this.instance.setTransform(-183,-21);

	this.instance_1 = new lib.ChatReplyOptionButtonHi();
	this.instance_1.setTransform(-183,-21);

	this.instance_2 = new lib.ChatReplyOptionButtonDisabled();
	this.instance_2.setTransform(-183,-21);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-183,-21,366,42);


(lib.ChatNewLine = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// text
	this.textField = new cjs.Text("New", "bold 12px 'Open Sans'", "#FF6B6B");
	this.textField.name = "textField";
	this.textField.textAlign = "center";
	this.textField.lineHeight = 18;
	this.textField.lineWidth = 37;
	this.textField.parent = this;
	this.textField.setTransform(330.35,2);
ranj.TextOffsetFixer.fix(this.textField);

	this.timeline.addTween(cjs.Tween.get(this.textField).wait(1));

	// line
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FF6B6B").ss(1,1,1).p("AZJAAIEcAAA9kAAMAvvAAA");
	this.shape.setTransform(191.325,10.15);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ChatNewLine, new cjs.Rectangle(1,0,380.7,20.4), null);


(lib.StatusIndicator = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {offline:0,online:1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// indicator
	this.instance = new lib.OfflineIndicator();
	this.instance.setTransform(-11,-11);

	this.instance_1 = new lib.OnlineIndicator();
	this.instance_1.setTransform(-11,-11);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-11,-11,21,21);


(lib.ChatContactItemHitArea = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(0,0,0,0)").ss(1,1,1).p("A+7lYMA93AAAIAAKxMg93AAAg");

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("rgba(255,255,255,0.008)").s().p("A+7FZIAAqxMA93AAAIAAKxg");

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ChatContactItemHitArea, new cjs.Rectangle(-199,-35.5,398,71), null);


(lib.WhiteBehindText = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// text
	this.textField = new cjs.Text("The day before yesterday", "bold 12px 'Open Sans'", "#999999");
	this.textField.name = "textField";
	this.textField.lineHeight = 18;
	this.textField.lineWidth = 152;
	this.textField.parent = this;
	this.textField.setTransform(-75.9,-8.15);
ranj.TextOffsetFixer.fix(this.textField);

	this.timeline.addTween(cjs.Tween.get(this.textField).wait(1));

	// bg
	this.instance = new lib.WhiteBar();
	this.instance.setTransform(-80,-11,1.0191,1.1579);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.WhiteBehindText, new cjs.Rectangle(-80,-11,160,22), null);


(lib.vinkjeIconBase = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.VinkjeIcon();
	this.instance.setTransform(-10,-7);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.vinkjeIconBase, new cjs.Rectangle(-10,-7,22,16), null);


(lib.SmartphoneCloseButon2Base = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.SmartphoneCloseButton();
	this.instance.setTransform(-38.5,-17.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SmartphoneCloseButon2Base, new cjs.Rectangle(-38.5,-17.5,77,35), null);


(lib.SmallBackButtonBase = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.BackButtonSmallIcon();
	this.instance.setTransform(-8.5,-10);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SmallBackButtonBase, new cjs.Rectangle(-8.5,-10,19,22), null);


(lib.SentIcon_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.instance = new lib.SentIcon();
	this.instance.setTransform(-14,-14);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SentIcon_1, new cjs.Rectangle(-14,-14,28,28), null);


(lib.SendButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"over":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.SendButtonUp();
	this.instance.setTransform(-22.5,-22.5);

	this.instance_1 = new lib.SendButtonDisabled();
	this.instance_1.setTransform(-22.5,-22.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},3).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-22.5,-22.5,47,47);


(lib.ScreenOverlayBase = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#67666F").s().p("EgYbA/rQisAAh6h6Qh6h7AAirMAAAhyVQAAisB6h6QB6h6CsAAMAw2AAAQCsAAB7B6QB6B6AACsMAAAByVQAACrh6B7Qh7B6isAAg");
	this.shape.setTransform(198,408.5011,1,1.0025);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ScreenOverlayBase, new cjs.Rectangle(0,0,396,817), null);


(lib.RoundEmpty = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(202,201,204,0.008)").s().p("AjTDUQhYhXAAh9QAAh7BYhYQBYhYB7AAQB8AABYBYQBYBYAAB7QAAB9hYBXQhYBYh8AAQh7AAhYhYg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.RoundEmpty, new cjs.Rectangle(-30,-30,60,60), null);


(lib.ReplyIcon_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.ReplyIcon();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ReplyIcon_1, new cjs.Rectangle(0,0,25,30), null);


(lib.NewIndicator = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"1digit":0,"2digits":1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// textField
	this.textField = new cjs.Text("3", "bold 18px 'Open Sans'", "#FFFFFF");
	this.textField.name = "textField";
	this.textField.textAlign = "center";
	this.textField.lineHeight = 27;
	this.textField.lineWidth = 22;
	this.textField.parent = this;
	this.textField.setTransform(0,-13);
ranj.TextOffsetFixer.fix(this.textField);

	this.timeline.addTween(cjs.Tween.get(this.textField).wait(1).to({x:-4.05,text:"33"},0).wait(1));

	// Layer_1
	this.instance = new lib.NewIndicatorLarge();
	this.instance.setTransform(-14,-14);

	this.instance_1 = new lib.RedPill();
	this.instance_1.setTransform(-23,-14);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-23,-15,39,29);


(lib.InboxIcon_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.instance = new lib.InboxIcon();
	this.instance.setTransform(-13,-12);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.InboxIcon_1, new cjs.Rectangle(-13,-12,25,24), null);


(lib.ImageContainer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,0,0);


(lib.EmptySquareDarkGrey = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(66,66,66,0.012)").s().p("AjbDcIAAm3IG3AAIAAG3g");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EmptySquareDarkGrey, new cjs.Rectangle(-22,-22,44,44), null);


(lib.EmptySquare = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(255,255,255,0.012)").s().p("AjbDcIAAm3IG3AAIAAG3g");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EmptySquare, new cjs.Rectangle(-22,-22,44,44), null);


(lib.EmptyListButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(255,255,255,0.008)").s().p("A+JGQIAAsfMA8TAAAIAAMfg");

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#EBEAEA").s().p("A+JGQIAAsfMA8TAAAIAAMfg");

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-193,-40,386,80);


(lib.EmptyContainer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,0,0);


(lib.EmailSentTextComponentSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.bodyTextField = new cjs.Text("Dear mayor,\n\nLorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam. ", "15px 'Open Sans'", "#333333");
	this.bodyTextField.name = "bodyTextField";
	this.bodyTextField.lineHeight = 26;
	this.bodyTextField.lineWidth = 357;
	this.bodyTextField.parent = this;
	this.bodyTextField.setTransform(2,2);
ranj.TextOffsetFixer.fix(this.bodyTextField);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextField).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EmailSentTextComponentSkin, new cjs.Rectangle(0,0,360.7,134.1), null);


(lib.EmailReceivedItemImageContainer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,0,0);


(lib.EmailDraftTextComponentSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.bodyTextField = new cjs.Text("Dear mayor,\n\nLorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam. ", "15px 'Open Sans'", "#333333");
	this.bodyTextField.name = "bodyTextField";
	this.bodyTextField.lineHeight = 26;
	this.bodyTextField.lineWidth = 304;
	this.bodyTextField.parent = this;
	this.bodyTextField.setTransform(2,2);
ranj.TextOffsetFixer.fix(this.bodyTextField);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextField).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EmailDraftTextComponentSkin, new cjs.Rectangle(0,0,308,156.7), null);


(lib.EditIconUp_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.EditIconUp();
	this.instance.setTransform(-11,-3);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EditIconUp_1, new cjs.Rectangle(-11,-3,22,6), null);


(lib.EditIconDisabeld = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.EditIconDisabled();
	this.instance.setTransform(-11,-3);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EditIconDisabeld, new cjs.Rectangle(-11,-3,22,6), null);


(lib.DropDownIcon = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.DropdownIcon();
	this.instance.setTransform(-9.5,-4);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DropDownIcon, new cjs.Rectangle(-9.5,-4,21,10), null);


(lib.DraftsIndicator = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// textField
	this.textField = new cjs.Text("3", "20px 'Open Sans'", "#534741");
	this.textField.name = "textField";
	this.textField.textAlign = "center";
	this.textField.lineHeight = 29;
	this.textField.lineWidth = 22;
	this.textField.parent = this;
	this.textField.setTransform(0,-13);
ranj.TextOffsetFixer.fix(this.textField);

	this.timeline.addTween(cjs.Tween.get(this.textField).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DraftsIndicator, new cjs.Rectangle(-13,-15,28,31.3), null);


(lib.DraftsIcon_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.instance = new lib.DraftsIcon();
	this.instance.setTransform(-13,-13);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DraftsIcon_1, new cjs.Rectangle(-13,-13,26,25), null);


(lib.ContentContainer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(255,255,255,0.012)").s().p("AgEAFIAAgJIAJAAIAAAJg");
	this.shape.setTransform(0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ContentContainer, new cjs.Rectangle(0,0,1,1), null);


(lib.ContactsIco = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.instance = new lib.ContactsIcon();
	this.instance.setTransform(-12,-11);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ContactsIco, new cjs.Rectangle(-12,-11,24,23), null);


(lib.CloseButtonBase = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.CloseButtonIcon();
	this.instance.setTransform(-10,-10);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.CloseButtonBase, new cjs.Rectangle(-10,-10,19,19), null);


(lib.ChoiceIndicator_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.ChoiceIndicator();
	this.instance.setTransform(-1,-1,2,1.0339);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ChoiceIndicator_1, new cjs.Rectangle(-1,-1,4,61), null);


(lib.ChatReplyOptionsPieletje_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.ChatReplyOptionsPieletje();
	this.instance.setTransform(-15,-7);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ChatReplyOptionsPieletje_1, new cjs.Rectangle(-15,-7,30,14), null);


(lib.ChatOptionsInput = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.textField = new cjs.Text("[Input must fill this whole textfield to correctly calculate the bounds... Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum]", "15px 'Open Sans'");
	this.textField.name = "textField";
	this.textField.lineHeight = 20;
	this.textField.lineWidth = 320;
	this.textField.parent = this;
	this.textField.setTransform(14.1,8.65);
ranj.TextOffsetFixer.fix(this.textField);

	this.timeline.addTween(cjs.Tween.get(this.textField).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ChatOptionsInput, new cjs.Rectangle(12.1,6.7,323.79999999999995,65.3), null);


(lib.BackButtonBase = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.BackButtonIcon();
	this.instance.setTransform(-11,-13);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.BackButtonBase, new cjs.Rectangle(-11,-13,22,26), null);


(lib.ListContentDragArea = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(255,255,255,0.012)").s().p("EgBFBMQMAAAiYfICLAAMAAACYfg");
	this.shape.setTransform(7,213);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ListContentDragArea, new cjs.Rectangle(0,-275,14,976.1), null);


(lib.DragButtonWhite = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_3
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AgdDFIAAmKIA7AAIAAGKg");
	this.shape.setTransform(0,1.25);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("rgba(255,255,255,0.008)").s().p("AgdAMIAAgXIA7AAIAAAXg");
	this.shape_1.setTransform(0,-19.75);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-3,-21,6,42);


(lib.DragButtonContactList = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_3
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#67666F").s().p("AgdDFIAAmKIA7AAIAAGKg");
	this.shape.setTransform(0,1.25);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("rgba(255,255,255,0.008)").s().p("AgdAMIAAgXIA7AAIAAAXg");
	this.shape_1.setTransform(0,-19.75);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DragButtonContactList, new cjs.Rectangle(-3,-21,6,42), null);


(lib.DragButtonAlmostWhite = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_3
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#EBEAEA").s().p("AgdDFIAAmKIA7AAIAAGKg");
	this.shape.setTransform(0,1.25);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("rgba(255,255,255,0.008)").s().p("AgdAMIAAgXIA7AAIAAAXg");
	this.shape_1.setTransform(0,-19.75);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DragButtonAlmostWhite, new cjs.Rectangle(-3,-21,6,42), null);


(lib.ChatContentDragAre = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#EBEAEA").s().p("EgA7BMQMAAAiYfIB3AAMAAACYfg");
	this.shape.setTransform(6,213);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ChatContentDragAre, new cjs.Rectangle(0,-275,12,976.1), null);


(lib.NoPortraitThumbSmall = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.EmptyThumb();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.NoPortraitThumbSmall, new cjs.Rectangle(0,0,66,66), null);


(lib.NoPortraitThumb = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.EmptyThumbBig();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.NoPortraitThumb, new cjs.Rectangle(0,0,80,80), null);


(lib.ChatStatusIndicator = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"offline":0,"online":1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// indicator
	this.instance = new lib.ChatOfflineIndicator();
	this.instance.setTransform(-11,-11);

	this.instance_1 = new lib.ChatOnlineIndicator();
	this.instance_1.setTransform(-11,-11);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-11,-11,21,21);


(lib.ChatOtherIndividualMessage = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// textField
	this.contentTextField = new cjs.Text("[This text should fill the whole row..................]", "15px 'Open Sans'");
	this.contentTextField.name = "contentTextField";
	this.contentTextField.lineHeight = 22;
	this.contentTextField.lineWidth = 319;
	this.contentTextField.parent = this;
	this.contentTextField.setTransform(24.85,17.5);
ranj.TextOffsetFixer.fix(this.contentTextField);

	this.timeline.addTween(cjs.Tween.get(this.contentTextField).wait(1));

	// bg
	this.instance = new lib.ChatNPCBalloon2();
	this.instance.setTransform(7,0);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ChatOtherIndividualMessage, new cjs.Rectangle(-1,-408.5,398,817), null);


(lib.ChatGroupMessage = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// textField
	this.nameTextField = new cjs.Text("Name", "bold 12px 'Open Sans'");
	this.nameTextField.name = "nameTextField";
	this.nameTextField.lineHeight = 18;
	this.nameTextField.lineWidth = 319;
	this.nameTextField.parent = this;
	this.nameTextField.setTransform(25,16);
ranj.TextOffsetFixer.fix(this.nameTextField);

	this.contentTextField = new cjs.Text("[This text should fill the whole row...................]", "15px 'Open Sans'");
	this.contentTextField.name = "contentTextField";
	this.contentTextField.lineHeight = 22;
	this.contentTextField.lineWidth = 319;
	this.contentTextField.parent = this;
	this.contentTextField.setTransform(25,36);
ranj.TextOffsetFixer.fix(this.contentTextField);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.contentTextField},{t:this.nameTextField}]}).wait(1));

	// bg
	this.instance = new lib.GroupChatNPCBalloon2();
	this.instance.setTransform(7,0);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ChatGroupMessage, new cjs.Rectangle(-1,-408.5,398,817), null);


(lib.SmartphoneOverlay = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(0,0,0,0.498)").s().p("EhP/AzkMAAAhnHMCf/AAAMAAABnHg");
	this.shape.setTransform(0.0063,0.0201,1.875,1.6364);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SmartphoneOverlay, new cjs.Rectangle(-960,-540,1920,1080), null);


(lib.IndicatorBackgroundButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_3
	this.instance = new lib.SmartphoneEmailIndicatorButtonBackground();
	this.instance.setTransform(0,0,1.0044,1);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,24);


(lib.EmailIcon = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"new":0,opened:1,newWithAttachment:2,openedWithAttachment:3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Attach
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#9F9F9F").s().p("AgaA6QgBAAAAgBQAAAAAAgBQAAAAAAgBQAAAAABgBIBQhKQAEgEgBgFQgBgHgEgEIgGgHQgFgFgGgBQgFgBgEADIhRBMQgCACAAAEQABAEADADIADAEQAIAHAGgFIA9g4IgBAAQADgDgDgFQgFgFgDADIgpAmQgBABAAAAQAAAAgBAAQAAAAgBAAQgBgBAAAAQgBgBAAAAQAAgBAAAAQAAgBAAgBQAAAAABgBIAoglQADgDAFABQAFABADADQAJAJgHAHIg9A5QgDADgHAAQgGgCgFgFIgDgEQgFgFgBgEIAAgDQgBgGAEgEIBRhKQAEgFAJABQAIACAGAGIAHAIQAGAGABAIQABAJgFAEIhRBLIgCABIgCgCg");
	this.shape.setTransform(16.0745,9.6727);
	this.shape._off = true;

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(2).to({_off:false},0).wait(2));

	// Layer_1
	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("AhbA7IAAh1IBcBcIBbhcIAAB1g");
	this.shape_1.setTransform(9.2,7.05);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("AhPgnICfAAIhQBPg");
	this.shape_2.setTransform(9.225,4);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("rgba(255,255,255,0.4)").s().p("AhbBBIAAh1IBcBbIBbhbIAAB1gAhPhAICgAAIhQBPg");
	this.shape_3.setTransform(9.2,6.475);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_2},{t:this.shape_1}]}).to({state:[{t:this.shape_3}]},1).to({state:[{t:this.shape_2},{t:this.shape_1}]},1).to({state:[{t:this.shape_3}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,22.4,15.7);


(lib.EmailDraftOptionOverlaySkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// textField
	this.pickAnswerTextField = new cjs.Text("Pick an answer", "bold 15px 'Open Sans'", "#FFFFFF");
	this.pickAnswerTextField.name = "pickAnswerTextField";
	this.pickAnswerTextField.textAlign = "center";
	this.pickAnswerTextField.lineHeight = 26;
	this.pickAnswerTextField.lineWidth = 225;
	this.pickAnswerTextField.parent = this;
	this.pickAnswerTextField.setTransform(0.5,-61);
ranj.TextOffsetFixer.fix(this.pickAnswerTextField);

	this.timeline.addTween(cjs.Tween.get(this.pickAnswerTextField).wait(1));

	// container
	this.container = new lib.EmptyContainer();
	this.container.name = "container";

	this.timeline.addTween(cjs.Tween.get(this.container).wait(1));

	// overlay
	this.overlay = new lib.ScreenOverlayBase();
	this.overlay.name = "overlay";
	this.overlay.setTransform(0,-1,1,1,0,0,0,198,407.5);
	this.overlay.alpha = 0.8008;

	this.timeline.addTween(cjs.Tween.get(this.overlay).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EmailDraftOptionOverlaySkin, new cjs.Rectangle(-198,-408.5,398,818), null);


(lib.SmsButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// newIndicator
	this.newIndicator = new lib.NewIndicator();
	this.newIndicator.name = "newIndicator";
	this.newIndicator.setTransform(41,-29);

	this.timeline.addTween(cjs.Tween.get(this.newIndicator).wait(1));

	// labelTextField
	this.labelTextField = new cjs.Text("Chat", "bold 15px 'Open Sans'", "#FFFFFF");
	this.labelTextField.name = "labelTextField";
	this.labelTextField.textAlign = "center";
	this.labelTextField.lineHeight = 22;
	this.labelTextField.lineWidth = 76;
	this.labelTextField.parent = this;
	this.labelTextField.setTransform(-0.5,40.85);
	this.labelTextField.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,4);
ranj.TextOffsetFixer.fix(this.labelTextField);

	this.timeline.addTween(cjs.Tween.get(this.labelTextField).wait(1));

	// button
	this.instance = new lib.ChatIcon();
	this.instance.setTransform(-41,-41);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SmsButton, new cjs.Rectangle(-45.5,-44,100.5,121.9), null);


(lib.EmailButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// newIndicator
	this.newIndicator = new lib.NewIndicator();
	this.newIndicator.name = "newIndicator";
	this.newIndicator.setTransform(41,-29);

	this.timeline.addTween(cjs.Tween.get(this.newIndicator).wait(1));

	// labelTextField
	this.labelTextField = new cjs.Text("Email", "bold 15px 'Open Sans'", "#FFFFFF");
	this.labelTextField.name = "labelTextField";
	this.labelTextField.textAlign = "center";
	this.labelTextField.lineHeight = 22;
	this.labelTextField.lineWidth = 76;
	this.labelTextField.parent = this;
	this.labelTextField.setTransform(-0.5,40.85);
	this.labelTextField.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,4);
ranj.TextOffsetFixer.fix(this.labelTextField);

	this.timeline.addTween(cjs.Tween.get(this.labelTextField).wait(1));

	// button
	this.instance = new lib.MailIcon();
	this.instance.setTransform(-41,-41);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EmailButton, new cjs.Rectangle(-45.5,-44,100.5,121.9), null);


(lib.SentButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Button text", "20px 'Open Sans'", "#534741");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 29;
	this.disabledLabelTextField.lineWidth = 284;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-133.95,-13.2);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Button text", "20px 'Open Sans'", "#534741");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 29;
	this.downLabelTextField.lineWidth = 293;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-133.95,-13.2);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Button text", "20px 'Open Sans'", "#534741");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 29;
	this.overLabelTextField.lineWidth = 294;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-133.95,-13.2);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Button text", "20px 'Open Sans'", "#534741");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 29;
	this.upLabelTextField.lineWidth = 294;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-133.95,-13.2);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// icon
	this.instance = new lib.SentIcon_1();
	this.instance.setTransform(-163,1,1,1,0,0,0,-0.5,0);
	var instanceFilter_1 = new cjs.ColorFilter(0,0,0,1,83,71,65,0);
	this.instance.filters = [instanceFilter_1];
	this.instance.cache(-16,-16,32,32);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(4));
	this.timeline.addTween(cjs.Tween.get(instanceFilter_1).wait(4));

	// bg
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(255,255,255,0.008)").s().p("A+7D6IAAnzMA93AAAIAAHzg");

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#BBD2D7").s().p("A+7D6IAAnzMA93AAAIAAHzg");

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.shape_1}]},2).to({state:[{t:this.shape}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-198,-25,396,50);


(lib.EmailBoxButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Button text", "20px 'Open Sans'", "#534741");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 29;
	this.disabledLabelTextField.lineWidth = 284;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-133.95,-13.2);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Button text", "20px 'Open Sans'", "#534741");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 29;
	this.downLabelTextField.lineWidth = 293;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-133.95,-13.2);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Button text", "20px 'Open Sans'", "#534741");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 29;
	this.overLabelTextField.lineWidth = 294;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-133.95,-13.2);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Button text", "20px 'Open Sans'", "#534741");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 29;
	this.upLabelTextField.lineWidth = 294;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-133.95,-13.2);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// indicator
	this.indicator = new lib.NewIndicator();
	this.indicator.name = "indicator";
	this.indicator.setTransform(168,0);

	this.timeline.addTween(cjs.Tween.get(this.indicator).wait(4));

	// icon
	this.instance = new lib.InboxIcon_1();
	this.instance.setTransform(-163,1,1,1,0,0,0,-0.5,0);
	var instanceFilter_1 = new cjs.ColorFilter(0,0,0,1,83,71,65,0);
	this.instance.filters = [instanceFilter_1];
	this.instance.cache(-15,-14,29,28);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(4));
	this.timeline.addTween(cjs.Tween.get(instanceFilter_1).wait(4));

	// bg
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(255,255,255,0.008)").s().p("A+7D6IAAnzMA93AAAIAAHzg");

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#BBD2D7").s().p("A+7D6IAAnzMA93AAAIAAHzg");

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.shape_1}]},2).to({state:[{t:this.shape}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-198,-25,396,50);


(lib.DraftsButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Button text", "20px 'Open Sans'", "#534741");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 29;
	this.disabledLabelTextField.lineWidth = 284;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-133.95,-13.2);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Button text", "20px 'Open Sans'", "#534741");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 29;
	this.downLabelTextField.lineWidth = 293;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-133.95,-13.2);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Button text", "20px 'Open Sans'", "#534741");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 29;
	this.overLabelTextField.lineWidth = 294;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-133.95,-13.2);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Button text", "20px 'Open Sans'", "#534741");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 29;
	this.upLabelTextField.lineWidth = 294;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-133.95,-13.2);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// indicator
	this.indicator = new lib.DraftsIndicator();
	this.indicator.name = "indicator";
	this.indicator.setTransform(168,0);

	this.timeline.addTween(cjs.Tween.get(this.indicator).wait(4));

	// icon
	this.instance = new lib.DraftsIcon_1();
	this.instance.setTransform(-163,1,1,1,0,0,0,-0.5,0);
	var instanceFilter_1 = new cjs.ColorFilter(0,0,0,1,83,71,65,0);
	this.instance.filters = [instanceFilter_1];
	this.instance.cache(-15,-15,30,29);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(4));
	this.timeline.addTween(cjs.Tween.get(instanceFilter_1).wait(4));

	// bg
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(255,255,255,0.008)").s().p("A+7D6IAAnzMA93AAAIAAHzg");

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#BBD2D7").s().p("A+7D6IAAnzMA93AAAIAAHzg");

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.shape_1}]},2).to({state:[{t:this.shape}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-198,-25,396,50);


(lib.ChatScrollPane = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// messageMask (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.p("EgXmA5KQinAAh2h6Qh3h7AAisMAAAhryMA71AAAMAAABwkQhzBvigAAg");
	mask.setTransform(191.5,365.775);

	// messageContainer
	this.messageContentContainer = new lib.EmptyContainer();
	this.messageContentContainer.name = "messageContentContainer";

	var maskedShapeInstanceList = [this.messageContentContainer];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.messageContentContainer).wait(1));

	// bg
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("EgYnA5KQinAAh2h6Qh3h7AAisMAAAhryMA93AAAMAAABryQAACsh3B7Qh3B6inAAg");
	this.shape.setTransform(198,365.775);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ChatScrollPane, new cjs.Rectangle(0,0,396,731.6), null);


(lib.ChatInputField = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// contentMask (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.p("A4cGGQigAAAAigIAAnBQAAigCgAAMAxDAAAQCgAAAACgIAAHBQAACgigAAg");
	mask.setTransform(173.5,39);

	// content
	this.scrollContainer = new lib.ChatOptionsInput();
	this.scrollContainer.name = "scrollContainer";

	var maskedShapeInstanceList = [this.scrollContainer];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.scrollContainer).wait(1));

	// bg
	this.instance = new lib.ChatReplyPreviewFieldBG();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ChatInputField, new cjs.Rectangle(0,0,348,79), null);


(lib.ChatDateLine = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// panel
	this.panel = new lib.WhiteBehindText();
	this.panel.name = "panel";
	this.panel.setTransform(96.5,11);

	this.timeline.addTween(cjs.Tween.get(this.panel).wait(1));

	// line
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#EBEAEA").ss(1,1,1).p("AdkAAMg7HAAA");
	this.shape.setTransform(190.95,10.9);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ChatDateLine, new cjs.Rectangle(0.8,0,380.4,22), null);


(lib.SmarthphoneCloseButtonAnim = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.SmartphoneCloseButon2Base();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SmarthphoneCloseButtonAnim, new cjs.Rectangle(-38.5,-17.5,77,35), null);


(lib.EmailDraftSendComponentSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// sentButton
	this.sentButton = new lib.SendButton();
	this.sentButton.name = "sentButton";
	this.sentButton.setTransform(295,22.5);

	this.timeline.addTween(cjs.Tween.get(this.sentButton).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EmailDraftSendComponentSkin, new cjs.Rectangle(272.5,0,47,47), null);


(lib.EmailDraftButton9SlideUp = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// vinkje
	this.checkmark = new lib.vinkjeIconBase();
	this.checkmark.name = "checkmark";
	this.checkmark.setTransform(-154,-4);
	var checkmarkFilter_1 = new cjs.ColorFilter(0,0,0,1,83,71,65,0);
	this.checkmark.filters = [checkmarkFilter_1];
	this.checkmark.cache(-12,-9,26,20);

	this.timeline.addTween(cjs.Tween.get(this.checkmark).wait(1));
	this.timeline.addTween(cjs.Tween.get(checkmarkFilter_1).wait(1));

	// Layer_3
	this.backArrow = new lib.SmallBackButtonBase();
	this.backArrow.name = "backArrow";
	this.backArrow.setTransform(-155,-4);
	var backArrowFilter_2 = new cjs.ColorFilter(0,0,0,1,83,71,65,0);
	this.backArrow.filters = [backArrowFilter_2];
	this.backArrow.cache(-10,-12,23,26);

	this.timeline.addTween(cjs.Tween.get(this.backArrow).wait(1));
	this.timeline.addTween(cjs.Tween.get(backArrowFilter_2).wait(1));

	// Layer_2
	this.textfield = new cjs.Text("No longer a short answer unfortunately.....", "15px 'Open Sans'", "#534741");
	this.textfield.name = "textfield";
	this.textfield.lineHeight = 20;
	this.textfield.lineWidth = 297;
	this.textfield.parent = this;
	this.textfield.setTransform(-129.5,-15);
ranj.TextOffsetFixer.fix(this.textfield);

	this.timeline.addTween(cjs.Tween.get(this.textfield).wait(1));

	// bg
	this.instance = new lib.ModalButtonBG();
	this.instance.setTransform(-183,-30);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EmailDraftButton9SlideUp, new cjs.Rectangle(-183,-30,367,52), null);


(lib.EmailDraftButton9SlideOver = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_4
	this.checkmark = new lib.vinkjeIconBase();
	this.checkmark.name = "checkmark";
	this.checkmark.setTransform(-154,-4);
	var checkmarkFilter_1 = new cjs.ColorFilter(0,0,0,1,83,71,65,0);
	this.checkmark.filters = [checkmarkFilter_1];
	this.checkmark.cache(-12,-9,26,20);

	this.timeline.addTween(cjs.Tween.get(this.checkmark).wait(1));
	this.timeline.addTween(cjs.Tween.get(checkmarkFilter_1).wait(1));

	// Layer_3
	this.backArrow = new lib.SmallBackButtonBase();
	this.backArrow.name = "backArrow";
	this.backArrow.setTransform(-155,-4);
	var backArrowFilter_2 = new cjs.ColorFilter(0,0,0,1,83,71,65,0);
	this.backArrow.filters = [backArrowFilter_2];
	this.backArrow.cache(-10,-12,23,26);

	this.timeline.addTween(cjs.Tween.get(this.backArrow).wait(1));
	this.timeline.addTween(cjs.Tween.get(backArrowFilter_2).wait(1));

	// Layer_2
	this.textfield = new cjs.Text("No longer a short answer unfortunately.....", "15px 'Open Sans'", "#534741");
	this.textfield.name = "textfield";
	this.textfield.lineHeight = 20;
	this.textfield.lineWidth = 297;
	this.textfield.parent = this;
	this.textfield.setTransform(-129.5,-15);
ranj.TextOffsetFixer.fix(this.textfield);

	this.timeline.addTween(cjs.Tween.get(this.textfield).wait(1));

	// Layer_1
	this.instance = new lib.ModalButtonBG();
	this.instance.setTransform(-183,-30);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EmailDraftButton9SlideOver, new cjs.Rectangle(-183,-30,367,52), null);


(lib.EmailDraftButton9SliceDown = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// vinkje
	this.checkmark = new lib.vinkjeIconBase();
	this.checkmark.name = "checkmark";
	this.checkmark.setTransform(-154,-4);

	this.timeline.addTween(cjs.Tween.get(this.checkmark).wait(1));

	// arrow
	this.backArrow = new lib.SmallBackButtonBase();
	this.backArrow.name = "backArrow";
	this.backArrow.setTransform(-155,-4);

	this.timeline.addTween(cjs.Tween.get(this.backArrow).wait(1));

	// Layer_2
	this.textfield = new cjs.Text("No longer a short answer unfortunately.....", "15px 'Open Sans'", "#FFFFFF");
	this.textfield.name = "textfield";
	this.textfield.lineHeight = 20;
	this.textfield.lineWidth = 297;
	this.textfield.parent = this;
	this.textfield.setTransform(-129.5,-15);
ranj.TextOffsetFixer.fix(this.textfield);

	this.timeline.addTween(cjs.Tween.get(this.textfield).wait(1));

	// bg
	this.instance = new lib.ModalButtonDown();
	this.instance.setTransform(-183,-30);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EmailDraftButton9SliceDown, new cjs.Rectangle(-183,-30,367,51), null);


(lib.EmailDraftButton9SliceDisabled = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// vinkje
	this.checkmark = new lib.vinkjeIconBase();
	this.checkmark.name = "checkmark";
	this.checkmark.setTransform(-154,-4);
	var checkmarkFilter_1 = new cjs.ColorFilter(0,0,0,1,235,234,234,0);
	this.checkmark.filters = [checkmarkFilter_1];
	this.checkmark.cache(-12,-9,26,20);

	this.timeline.addTween(cjs.Tween.get(this.checkmark).wait(1));
	this.timeline.addTween(cjs.Tween.get(checkmarkFilter_1).wait(1));

	// arrow
	this.backArrow = new lib.SmallBackButtonBase();
	this.backArrow.name = "backArrow";
	this.backArrow.setTransform(-155,-4);
	var backArrowFilter_2 = new cjs.ColorFilter(0,0,0,1,235,234,234,0);
	this.backArrow.filters = [backArrowFilter_2];
	this.backArrow.cache(-10,-12,23,26);

	this.timeline.addTween(cjs.Tween.get(this.backArrow).wait(1));
	this.timeline.addTween(cjs.Tween.get(backArrowFilter_2).wait(1));

	// textfield
	this.textfield = new cjs.Text("No longer a short answer unfortunately.....", "15px 'Open Sans'", "#EBEAEA");
	this.textfield.name = "textfield";
	this.textfield.lineHeight = 20;
	this.textfield.lineWidth = 297;
	this.textfield.parent = this;
	this.textfield.setTransform(-129.5,-15);
ranj.TextOffsetFixer.fix(this.textfield);

	this.timeline.addTween(cjs.Tween.get(this.textfield).wait(1));

	// bg
	this.instance = new lib.ModalButtonBG();
	this.instance.setTransform(-183,-30);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EmailDraftButton9SliceDisabled, new cjs.Rectangle(-183,-30,367,52), null);


(lib.TopBarWhiteBackButto = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// hitArea
	this.hitArea = new lib.EmptySquare();
	this.hitArea.name = "hitArea";

	this.timeline.addTween(cjs.Tween.get(this.hitArea).wait(4));

	// Layer_4
	this.instance = new lib.BackButtonBase();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2).to({scaleX:0.8325,scaleY:0.8333},0).wait(1).to({scaleX:1,scaleY:1},0).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-22,-22,44,44);


(lib.TopBarCloseWindowWhiteButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// hitArea
	this.hitArea = new lib.EmptySquareDarkGrey();
	this.hitArea.name = "hitArea";

	this.timeline.addTween(cjs.Tween.get(this.hitArea).wait(4));

	// Layer_2
	this.instance = new lib.CloseButtonBase();
	this.instance.setTransform(-0.5,-0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2).to({scaleX:0.8235,scaleY:0.8235},0).wait(1).to({scaleX:1,scaleY:1},0).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-22,-22,44,44);


(lib.TopBarCloseWindowButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// hitArea
	this.hitArea = new lib.EmptySquare();
	this.hitArea.name = "hitArea";

	this.timeline.addTween(cjs.Tween.get(this.hitArea).wait(4));

	// Layer_2
	this.instance = new lib.CloseButtonBase();
	this.instance.setTransform(0.5,0.5);
	var instanceFilter_1 = new cjs.ColorFilter(0,0,0,1,83,71,65,0);
	this.instance.filters = [instanceFilter_1];
	this.instance.cache(-12,-12,23,23);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2).to({scaleX:0.8235,scaleY:0.8235,x:0.4,y:0.4},0).wait(1).to({scaleX:1,scaleY:1,x:0.5,y:0.5},0).wait(1));
	this.timeline.addTween(cjs.Tween.get(instanceFilter_1).wait(2).to(new cjs.ColorFilter(0,0,0,1,103,102,111,0), 0).wait(1).to(new cjs.ColorFilter(0,0,0,1,235,234,234,0), 0).wait(1));

	this.filterCacheList = [];
	this.filterCacheList.push({instance: this.instance, startFrame:2, endFrame:2, x:-12, y:-12, w:23, h:23});
	this.filterCacheList.push({instance: this.instance, startFrame:0, endFrame:0, x:-12, y:-12, w:23, h:23});
	this.filterCacheList.push({instance: this.instance, startFrame:3, endFrame:3, x:-12, y:-12, w:23, h:23});
	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-22,-22,44,44);


(lib.TopBarBackButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// hitArea
	this.hitArea = new lib.EmptySquare();
	this.hitArea.name = "hitArea";

	this.timeline.addTween(cjs.Tween.get(this.hitArea).wait(4));

	// Layer_4
	this.instance = new lib.BackButtonBase();
	var instanceFilter_1 = new cjs.ColorFilter(0,0,0,1,103,102,111,0);
	this.instance.filters = [instanceFilter_1];
	this.instance.cache(-13,-15,26,30);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2).to({scaleX:0.8325,scaleY:0.8333},0).wait(1).to({scaleX:1,scaleY:1},0).wait(1));
	this.timeline.addTween(cjs.Tween.get(instanceFilter_1).wait(3).to(new cjs.ColorFilter(0,0,0,1,235,234,234,0), 0).wait(1));

	this.filterCacheList = [];
	this.filterCacheList.push({instance: this.instance, startFrame:3, endFrame:3, x:-13, y:-15, w:26, h:30});
	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-22,-22,44,44);


(lib.VScrollBarInbox = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = false; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.dragButton = new lib.DragButtonAlmostWhite();
	this.dragButton.name = "dragButton";
	this.dragButton.setTransform(6,21);

	this.dragArea = new lib.ListContentDragArea();
	this.dragArea.name = "dragArea";
	this.dragArea.setTransform(-0.5,197.5,1,0.7182);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.dragArea},{t:this.dragButton}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.VScrollBarInbox, new cjs.Rectangle(-0.5,0,14,701), null);


(lib.VScrollBarContactList = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = false; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.dragButton = new lib.DragButtonContactList();
	this.dragButton.name = "dragButton";
	this.dragButton.setTransform(6,21);

	this.dragArea = new lib.ListContentDragArea();
	this.dragArea.name = "dragArea";
	this.dragArea.setTransform(-0.5,197.5,1,0.7182);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.dragArea},{t:this.dragButton}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.VScrollBarContactList, new cjs.Rectangle(-0.5,0,14,701), null);


(lib.VScrollBarChat = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = false; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.dragButton = new lib.DragButtonWhite();
	this.dragButton.name = "dragButton";
	this.dragButton.setTransform(6,21);

	this.dragArea = new lib.ChatContentDragAre();
	this.dragArea.name = "dragArea";
	this.dragArea.setTransform(0,197.5,1,0.7182);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.dragArea},{t:this.dragButton}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.VScrollBarChat, new cjs.Rectangle(0,0,12,701), null);


(lib.ScrollPaneInbox2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = false; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// emptyIndicationTextField
	this.emptyIndicationTextField = new cjs.Text("There are no conversations in this box.", "16px 'Open Sans'", "#1E1E28");
	this.emptyIndicationTextField.name = "emptyIndicationTextField";
	this.emptyIndicationTextField.textAlign = "center";
	this.emptyIndicationTextField.lineHeight = 24;
	this.emptyIndicationTextField.lineWidth = 365;
	this.emptyIndicationTextField.parent = this;
	this.emptyIndicationTextField.setTransform(191.5,13.4);
ranj.TextOffsetFixer.fix(this.emptyIndicationTextField);

	this.timeline.addTween(cjs.Tween.get(this.emptyIndicationTextField).wait(1));

	// ScrollArea
	this.vScrollBar = new lib.VScrollBarInbox();
	this.vScrollBar.name = "vScrollBar";
	this.vScrollBar.setTransform(382.5,0);

	this.timeline.addTween(cjs.Tween.get(this.vScrollBar).wait(1));

	// Mask (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.p("EgYbA50QisAAh6h6Qh6h6AAitMAAAhtGMA93AAAMAAABtGQAACth6B6Qh7B6isAAg");
	mask.setTransform(198,370);

	// Container
	this.contentContainer = new lib.ContentContainer();
	this.contentContainer.name = "contentContainer";

	var maskedShapeInstanceList = [this.contentContainer];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.contentContainer).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ScrollPaneInbox2, new cjs.Rectangle(-1,-1,397,741), null);


(lib.ScrollPaneContacts = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = false; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Mask (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.p("EgYbA50QisAAh6h6Qh6h6AAitMAAAhtGMA93AAAMAAABtGQAACth6B6Qh7B6isAAg");
	mask.setTransform(198,370);

	// Container
	this.contentContainer = new lib.ContentContainer();
	this.contentContainer.name = "contentContainer";

	var maskedShapeInstanceList = [this.contentContainer];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.contentContainer).wait(1));

	// Mask_copy
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(103,102,111,0.008)").s().p("EgYbA50QisAAh6h6Qh6h6AAitMAAAhtGMA93AAAMAAABtGQAACth6B6Qh7B6isAAg");
	this.shape.setTransform(198,370);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ScrollPaneContacts, new cjs.Rectangle(0,0,396,740), null);


(lib.ScrollPane = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = false; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// ScrollArea
	this.vScrollBar = new lib.VScrollBarChat();
	this.vScrollBar.name = "vScrollBar";
	this.vScrollBar.setTransform(383.5,0);

	this.timeline.addTween(cjs.Tween.get(this.vScrollBar).wait(1));

	// Mask (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.p("EgYbA5aQisAAh6h6Qh6h6AAisMAAAhsTMA93AAAMAAABsTQAACsh6B6Qh7B6isAAg");
	mask.setTransform(198,367.95);

	// Container
	this.contentContainer = new lib.ContentContainer();
	this.contentContainer.name = "contentContainer";
	this.contentContainer.setTransform(4,6);

	var maskedShapeInstanceList = [this.contentContainer];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.contentContainer).wait(1));

	// bg
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#EBEAEA").s().p("EgYbA5bQisAAh6h5Qh6h6AAiqMAAAhsYMA93AAAMAAABsYQAACqh6B6Qh7B5isAAg");
	this.shape.setTransform(198,367.525);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ScrollPane, new cjs.Rectangle(0,0,396,735.1), null);


(lib.ChatTopInfo = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// statusTextField
	this.titleTextField = new cjs.Text("[Title]", "12px 'Open Sans'", "#FFFFFF");
	this.titleTextField.name = "titleTextField";
	this.titleTextField.lineHeight = 18;
	this.titleTextField.lineWidth = 226;
	this.titleTextField.parent = this;
	this.titleTextField.setTransform(88.5,23.85);
ranj.TextOffsetFixer.fix(this.titleTextField);

	this.timeline.addTween(cjs.Tween.get(this.titleTextField).wait(1));

	// titleTextField
	this.statusTextField = new cjs.Text("[Status]", "12px 'Open Sans'", "#FFFFFF");
	this.statusTextField.name = "statusTextField";
	this.statusTextField.lineHeight = 18;
	this.statusTextField.lineWidth = 226;
	this.statusTextField.parent = this;
	this.statusTextField.setTransform(88.5,44.2);
ranj.TextOffsetFixer.fix(this.statusTextField);

	this.timeline.addTween(cjs.Tween.get(this.statusTextField).wait(1));

	// nameTextField
	this.nameTextField = new cjs.Text("[Name]", "bold 15px 'Open Sans'", "#FFFFFF");
	this.nameTextField.name = "nameTextField";
	this.nameTextField.lineHeight = 22;
	this.nameTextField.lineWidth = 238;
	this.nameTextField.parent = this;
	this.nameTextField.setTransform(88.5,3.5);
ranj.TextOffsetFixer.fix(this.nameTextField);

	this.timeline.addTween(cjs.Tween.get(this.nameTextField).wait(1));

	// statusIndicator
	this.statusIndicator = new lib.ChatStatusIndicator();
	this.statusIndicator.name = "statusIndicator";
	this.statusIndicator.setTransform(69,54);

	this.timeline.addTween(cjs.Tween.get(this.statusIndicator).wait(1));

	// imageContainer
	this.imageContainer = new lib.ImageContainer();
	this.imageContainer.name = "imageContainer";
	this.imageContainer.setTransform(13,-3.45);

	this.timeline.addTween(cjs.Tween.get(this.imageContainer).wait(1));

	// noPortraitThumb
	this.noPortraitThumb = new lib.NoPortraitThumbSmall();
	this.noPortraitThumb.name = "noPortraitThumb";
	this.noPortraitThumb.setTransform(46,29.55,1,1,0,0,0,33,33);

	this.timeline.addTween(cjs.Tween.get(this.noPortraitThumb).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ChatTopInfo, new cjs.Rectangle(13,-3.4,315.2,67.4), null);


(lib.EmailSentPlayerTextSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.indentLine = new lib.ChoiceIndicator_1();
	this.indentLine.name = "indentLine";
	this.indentLine.setTransform(1,10);
	var indentLineFilter_1 = new cjs.ColorFilter(0,0,0,1,85,164,200,0);
	this.indentLine.filters = [indentLineFilter_1];
	this.indentLine.cache(-3,-3,8,65);

	this.timeline.addTween(cjs.Tween.get(this.indentLine).wait(1));
	this.timeline.addTween(cjs.Tween.get(indentLineFilter_1).wait(1));

	// disabledLabelTextField
	this.textField = new cjs.Text("Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut", "italic 15px 'Open Sans'", "#333333");
	this.textField.name = "textField";
	this.textField.lineHeight = 25;
	this.textField.lineWidth = 296;
	this.textField.parent = this;
	this.textField.setTransform(19.55,2);
ranj.TextOffsetFixer.fix(this.textField);

	this.timeline.addTween(cjs.Tween.get(this.textField).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EmailSentPlayerTextSkin, new cjs.Rectangle(0,0,317.6,80.9), null);


(lib.EmailReceivedItemSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// nameTextField
	this.subjectTextField = new cjs.Text("Meeting Lorem Ipsum", "bold 15px 'Open Sans'", "#333333");
	this.subjectTextField.name = "subjectTextField";
	this.subjectTextField.lineHeight = 22;
	this.subjectTextField.lineWidth = 218;
	this.subjectTextField.parent = this;
	this.subjectTextField.setTransform(159.25,72.25);
ranj.TextOffsetFixer.fix(this.subjectTextField);

	this.subjectLabelTextField = new cjs.Text("Subject:", "15px 'Open Sans'", "#333333");
	this.subjectLabelTextField.name = "subjectLabelTextField";
	this.subjectLabelTextField.lineHeight = 22;
	this.subjectLabelTextField.lineWidth = 64;
	this.subjectLabelTextField.parent = this;
	this.subjectLabelTextField.setTransform(102,72.3);
ranj.TextOffsetFixer.fix(this.subjectLabelTextField);

	this.toTextField = new cjs.Text("You", "bold 15px 'Open Sans'", "#333333");
	this.toTextField.name = "toTextField";
	this.toTextField.lineHeight = 22;
	this.toTextField.lineWidth = 242;
	this.toTextField.parent = this;
	this.toTextField.setTransform(127.05,52);
ranj.TextOffsetFixer.fix(this.toTextField);

	this.toLabelTextField = new cjs.Text("To:", "15px 'Open Sans'", "#333333");
	this.toLabelTextField.name = "toLabelTextField";
	this.toLabelTextField.lineHeight = 22;
	this.toLabelTextField.lineWidth = 26;
	this.toLabelTextField.parent = this;
	this.toLabelTextField.setTransform(102,52);
ranj.TextOffsetFixer.fix(this.toLabelTextField);

	this.nameTextField = new cjs.Text("John Doe", "bold 15px 'Open Sans'", "#78A5AF");
	this.nameTextField.name = "nameTextField";
	this.nameTextField.lineHeight = 22;
	this.nameTextField.lineWidth = 267;
	this.nameTextField.parent = this;
	this.nameTextField.setTransform(101.9,21.9);
ranj.TextOffsetFixer.fix(this.nameTextField);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.nameTextField},{t:this.toLabelTextField},{t:this.toTextField},{t:this.subjectLabelTextField},{t:this.subjectTextField}]}).wait(1));

	// bodyTextField
	this.bodyTextField = new cjs.Text("Dear mayor,\n\nLorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam. \n\nKind regards,\nJohn Doe", "15px 'Open Sans'", "#333333");
	this.bodyTextField.name = "bodyTextField";
	this.bodyTextField.lineHeight = 26;
	this.bodyTextField.lineWidth = 352;
	this.bodyTextField.parent = this;
	this.bodyTextField.setTransform(20,113);
ranj.TextOffsetFixer.fix(this.bodyTextField);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextField).wait(1));

	// imageContainer
	this.imageContainer = new lib.EmailReceivedItemImageContainer();
	this.imageContainer.name = "imageContainer";
	this.imageContainer.setTransform(14,17);

	this.timeline.addTween(cjs.Tween.get(this.imageContainer).wait(1));

	// noPortraitThumb
	this.noPortraitThumb = new lib.NoPortraitThumb();
	this.noPortraitThumb.name = "noPortraitThumb";
	this.noPortraitThumb.setTransform(14,17);

	this.timeline.addTween(cjs.Tween.get(this.noPortraitThumb).wait(1));

	// bg
	this.background = new lib.EmailReceivedItemBackground();
	this.background.name = "background";

	this.timeline.addTween(cjs.Tween.get(this.background).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EmailReceivedItemSkin, new cjs.Rectangle(5,3,377,340), null);


(lib.EmailDraftItemSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// contentContainer
	this.contentContainer = new lib.ContentContainer();
	this.contentContainer.name = "contentContainer";
	this.contentContainer.setTransform(45.8,16);

	this.timeline.addTween(cjs.Tween.get(this.contentContainer).wait(1));

	// replyIcon
	this.replyIcon = new lib.ReplyIcon_1();
	this.replyIcon.name = "replyIcon";
	this.replyIcon.setTransform(26,33.5,1,1,0,0,0,12,14.5);

	this.timeline.addTween(cjs.Tween.get(this.replyIcon).wait(1));

	// bg
	this.instance = new lib.DraftBG();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EmailDraftItemSkin, new cjs.Rectangle(0,0,518,321), null);


(lib.EmailDraftInputButtonUp = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// textfield
	this.textfield = new cjs.Text("Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibhhi euismod tincidunt utiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiii", "15px 'Open Sans'", "#333333");
	this.textfield.name = "textfield";
	this.textfield.lineHeight = 26;
	this.textfield.lineWidth = 295;
	this.textfield.parent = this;
	this.textfield.setTransform(2,16);
ranj.TextOffsetFixer.fix(this.textfield);

	this.timeline.addTween(cjs.Tween.get(this.textfield).wait(1));

	// icon
	this.icon = new lib.EditIconUp_1();
	this.icon.name = "icon";
	this.icon.setTransform(284,98);

	this.timeline.addTween(cjs.Tween.get(this.icon).wait(1));

	// bitmap
	this.instance = new lib.ChoiceButtonUp();
	this.instance.setTransform(-18,0);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EmailDraftInputButtonUp, new cjs.Rectangle(-18,0,335,116), null);


(lib.EmailDraftInputButtonOver = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// textfield
	this.textfield = new cjs.Text("Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibhhi euismod tincidunt utiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiii", "15px 'Open Sans'", "#333333");
	this.textfield.name = "textfield";
	this.textfield.lineHeight = 26;
	this.textfield.lineWidth = 295;
	this.textfield.parent = this;
	this.textfield.setTransform(2,16);
ranj.TextOffsetFixer.fix(this.textfield);

	this.timeline.addTween(cjs.Tween.get(this.textfield).wait(1));

	// icon
	this.icon = new lib.EditIconUp_1();
	this.icon.name = "icon";
	this.icon.setTransform(284,98);

	this.timeline.addTween(cjs.Tween.get(this.icon).wait(1));

	// Layer_1
	this.instance = new lib.ChoiceButtonHi();
	this.instance.setTransform(-18,0);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EmailDraftInputButtonOver, new cjs.Rectangle(-18,0,335,116), null);


(lib.EmailDraftInputButtonDown = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// textfield
	this.textfield = new cjs.Text("Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibhhi euismod tincidunt utiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiii", "15px 'Open Sans'", "#333333");
	this.textfield.name = "textfield";
	this.textfield.lineHeight = 26;
	this.textfield.lineWidth = 295;
	this.textfield.parent = this;
	this.textfield.setTransform(2,16);
ranj.TextOffsetFixer.fix(this.textfield);

	this.timeline.addTween(cjs.Tween.get(this.textfield).wait(1));

	// icon
	this.icon = new lib.EditIconUp_1();
	this.icon.name = "icon";
	this.icon.setTransform(284,98);

	this.timeline.addTween(cjs.Tween.get(this.icon).wait(1));

	// bitmap
	this.instance = new lib.ChoiceButtonHi();
	this.instance.setTransform(-18,0);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EmailDraftInputButtonDown, new cjs.Rectangle(-18,0,335,116), null);


(lib.EmailDraftInputButtonDisabled = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// textfield
	this.textfield = new cjs.Text("Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibhhi euismod tincidunt utiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiii", "15px 'Open Sans'", "#BBD2D7");
	this.textfield.name = "textfield";
	this.textfield.lineHeight = 26;
	this.textfield.lineWidth = 295;
	this.textfield.parent = this;
	this.textfield.setTransform(2,16);
ranj.TextOffsetFixer.fix(this.textfield);

	this.timeline.addTween(cjs.Tween.get(this.textfield).wait(1));

	// icon
	this.icon = new lib.EditIconDisabeld();
	this.icon.name = "icon";
	this.icon.setTransform(284,98);

	this.timeline.addTween(cjs.Tween.get(this.icon).wait(1));

	// bitmap
	this.instance = new lib.ChoiceButtonDisabled();
	this.instance.setTransform(-18,0);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EmailDraftInputButtonDisabled, new cjs.Rectangle(-18,0,335,116), null);


(lib.EmailDraftInputSelectionComponentSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// up
	this.upLabelTextField = new cjs.Text("Pick an answer", "15px 'Open Sans'", "#333333");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 26;
	this.upLabelTextField.lineWidth = 262;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(24.95,13.1);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// over
	this.overLabelTextField = new cjs.Text("Pick an answer", "15px 'Open Sans'", "#333333");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 26;
	this.overLabelTextField.lineWidth = 262;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(24.95,13.1);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// down
	this.downLabelTextField = new cjs.Text("Pick an answer", "15px 'Open Sans'", "#333333");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 26;
	this.downLabelTextField.lineWidth = 262;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(24.95,13.1);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// disabled
	this.disabledLabelTextField = new cjs.Text("Pick an answer", "15px 'Open Sans'", "#333333");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 26;
	this.disabledLabelTextField.lineWidth = 262;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(24.95,13.1);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// icon
	this.icon = new lib.DropDownIcon();
	this.icon.name = "icon";
	this.icon.setTransform(292.5,26);
	var iconFilter_1 = new cjs.ColorFilter(0,0,0,1,51,51,51,0);
	this.icon.filters = [iconFilter_1];
	this.icon.cache(-11,-6,25,14);

	this.timeline.addTween(cjs.Tween.get(this.icon).wait(4));
	this.timeline.addTween(cjs.Tween.get(iconFilter_1).wait(2).to(new cjs.ColorFilter(1,1,1,1,0,0,0,0), 0).wait(1).to(new cjs.ColorFilter(0,0,0,1,85,164,200,0), 0).wait(1));

	// Layer_1
	this.instance = new lib.EmailDraftInputButtonBackground();
	this.instance.setTransform(0,0,0.9877,1);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(4));

	this.filterCacheList = [];
	this.filterCacheList.push({instance: this.icon, startFrame:2, endFrame:2, x:-11, y:-6, w:25, h:14});
	this.filterCacheList.push({instance: this.icon, startFrame:0, endFrame:0, x:-11, y:-6, w:25, h:14});
	this.filterCacheList.push({instance: this.icon, startFrame:3, endFrame:3, x:-11, y:-6, w:25, h:14});
	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,320,50);


(lib.EmailConversationListItemSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"new":0,"opened":1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// imageContainer
	this.imageContainer = new lib.EmailReceivedItemImageContainer();
	this.imageContainer.name = "imageContainer";
	this.imageContainer.setTransform(12,5.5);

	this.timeline.addTween(cjs.Tween.get(this.imageContainer).wait(2));

	// noPortraitThumb
	this.noPortraitThumb = new lib.NoPortraitThumbSmall();
	this.noPortraitThumb.name = "noPortraitThumb";
	this.noPortraitThumb.setTransform(12,5.5);

	this.timeline.addTween(cjs.Tween.get(this.noPortraitThumb).wait(2));

	// textFields
	this.subjectTextField = new cjs.Text("Meeting Lorem Ipsum", "bold 15px 'Open Sans'", "#333333");
	this.subjectTextField.name = "subjectTextField";
	this.subjectTextField.lineHeight = 22;
	this.subjectTextField.lineWidth = 279;
	this.subjectTextField.parent = this;
	this.subjectTextField.setTransform(86,41.5);
ranj.TextOffsetFixer.fix(this.subjectTextField);

	this.nameTextField = new cjs.Text("John Doe", "bold 15px 'Open Sans'", "#55A4C8");
	this.nameTextField.name = "nameTextField";
	this.nameTextField.lineHeight = 22;
	this.nameTextField.lineWidth = 284;
	this.nameTextField.parent = this;
	this.nameTextField.setTransform(86,14.5);
ranj.TextOffsetFixer.fix(this.nameTextField);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.nameTextField,p:{scaleX:1,x:86,font:"bold 15px 'Open Sans'",color:"#55A4C8",lineWidth:284}},{t:this.subjectTextField,p:{font:"bold 15px 'Open Sans'"}}]}).to({state:[{t:this.nameTextField,p:{scaleX:1.1202,x:86.25,font:"15px 'Open Sans'",color:"#78A5AF",lineWidth:267}},{t:this.subjectTextField,p:{font:"15px 'Open Sans'"}}]},1).wait(1));

	// button
	this.button = new lib.EmptyListButton();
	this.button.name = "button";
	this.button.setTransform(193,40);

	this.timeline.addTween(cjs.Tween.get(this.button).wait(2));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,387.8,80);


(lib.ChatContactItem = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// hitArea
	this.hitArea = new lib.ChatContactItemHitArea();
	this.hitArea.name = "hitArea";
	this.hitArea.setTransform(198,34.5);

	this.timeline.addTween(cjs.Tween.get(this.hitArea).wait(1));

	// newIndicator
	this.newIndicator = new lib.NewIndicator();
	this.newIndicator.name = "newIndicator";
	this.newIndicator.setTransform(361.75,32.75);

	this.timeline.addTween(cjs.Tween.get(this.newIndicator).wait(1));

	// statusTextField
	this.titleTextField = new cjs.Text("[Title]", "15px 'Open Sans'", "#EBEAEA");
	this.titleTextField.name = "titleTextField";
	this.titleTextField.lineHeight = 22;
	this.titleTextField.lineWidth = 226;
	this.titleTextField.parent = this;
	this.titleTextField.setTransform(93.5,23.85);
ranj.TextOffsetFixer.fix(this.titleTextField);

	this.timeline.addTween(cjs.Tween.get(this.titleTextField).wait(1));

	// titleTextField
	this.statusTextField = new cjs.Text("[Status]", "15px 'Open Sans'", "#EBEAEA");
	this.statusTextField.name = "statusTextField";
	this.statusTextField.lineHeight = 22;
	this.statusTextField.lineWidth = 226;
	this.statusTextField.parent = this;
	this.statusTextField.setTransform(93.5,44.2);
ranj.TextOffsetFixer.fix(this.statusTextField);

	this.timeline.addTween(cjs.Tween.get(this.statusTextField).wait(1));

	// nameTextField
	this.nameTextField = new cjs.Text("[Name]", "bold 15px 'Open Sans'", "#55A4C8");
	this.nameTextField.name = "nameTextField";
	this.nameTextField.lineHeight = 22;
	this.nameTextField.lineWidth = 246;
	this.nameTextField.parent = this;
	this.nameTextField.setTransform(93.5,3.5);
ranj.TextOffsetFixer.fix(this.nameTextField);

	this.timeline.addTween(cjs.Tween.get(this.nameTextField).wait(1));

	// statusIndicator
	this.statusIndicator = new lib.StatusIndicator();
	this.statusIndicator.name = "statusIndicator";
	this.statusIndicator.setTransform(75,56);

	this.timeline.addTween(cjs.Tween.get(this.statusIndicator).wait(1));

	// imageContainer
	this.imageContainer = new lib.ImageContainer();
	this.imageContainer.name = "imageContainer";
	this.imageContainer.setTransform(13,0);

	this.timeline.addTween(cjs.Tween.get(this.imageContainer).wait(1));

	// noPortraitThumb
	this.noPortraitThumb = new lib.NoPortraitThumbSmall();
	this.noPortraitThumb.name = "noPortraitThumb";
	this.noPortraitThumb.setTransform(13,0);

	this.timeline.addTween(cjs.Tween.get(this.noPortraitThumb).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ChatContactItem, new cjs.Rectangle(-0.5,-0.5,397,70), null);


(lib.SmartphoneEmailIndicatorButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// emailIcon
	this.icon = new lib.EmailIcon();
	this.icon.name = "icon";
	this.icon.setTransform(9,10);

	this.timeline.addTween(cjs.Tween.get(this.icon).wait(1));

	// textFields
	this.subjectTextField = new cjs.Text("Email Body text", "12px 'Open Sans'", "#FFFFFF");
	this.subjectTextField.name = "subjectTextField";
	this.subjectTextField.lineHeight = 18;
	this.subjectTextField.lineWidth = 185;
	this.subjectTextField.parent = this;
	this.subjectTextField.setTransform(36,16.35);
ranj.TextOffsetFixer.fix(this.subjectTextField);

	this.senderTextField = new cjs.Text("Wethouder Sjakie", "12px 'Open Sans'", "#FFFFFF");
	this.senderTextField.name = "senderTextField";
	this.senderTextField.lineHeight = 18;
	this.senderTextField.lineWidth = 185;
	this.senderTextField.parent = this;
	this.senderTextField.setTransform(36,2.35);
ranj.TextOffsetFixer.fix(this.senderTextField);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.senderTextField},{t:this.subjectTextField}]}).wait(1));

	// bg
	this.button = new lib.IndicatorBackgroundButton();
	this.button.name = "button";
	this.button.setTransform(113.5,17.65,1,1.4583,0,0,0,113.5,12.1);

	this.timeline.addTween(cjs.Tween.get(this.button).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SmartphoneEmailIndicatorButton, new cjs.Rectangle(0,0,227,35), null);


(lib.SmartphoneMainScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// smsButton
	this.smsButton = new lib.SmsButton();
	this.smsButton.name = "smsButton";
	this.smsButton.setTransform(47,-258);

	this.timeline.addTween(cjs.Tween.get(this.smsButton).wait(1));

	// emailButton
	this.emailButton = new lib.EmailButton();
	this.emailButton.name = "emailButton";
	this.emailButton.setTransform(-58,-258);

	this.timeline.addTween(cjs.Tween.get(this.emailButton).wait(1));

	// bg
	this.instance = new lib.PhoneBG_dummy();
	this.instance.setTransform(-199,-409);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SmartphoneMainScreenSkin, new cjs.Rectangle(-199,-409,398,817), null);


(lib.SmartphoneEmailConversationScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// titleTextField
	this.applicationTitleTextField = new cjs.Text("E-mail Inbox", "24px 'Open Sans'", "#534741");
	this.applicationTitleTextField.name = "applicationTitleTextField";
	this.applicationTitleTextField.textAlign = "center";
	this.applicationTitleTextField.lineHeight = 35;
	this.applicationTitleTextField.lineWidth = 307;
	this.applicationTitleTextField.parent = this;
	this.applicationTitleTextField.setTransform(-5.45,-382.7);
ranj.TextOffsetFixer.fix(this.applicationTitleTextField);

	this.timeline.addTween(cjs.Tween.get(this.applicationTitleTextField).wait(1));

	// topBarNavButtons
	this.backButton = new lib.TopBarBackButton();
	this.backButton.name = "backButton";
	this.backButton.setTransform(-167,-364);

	this.closeButton = new lib.TopBarCloseWindowButton();
	this.closeButton.name = "closeButton";
	this.closeButton.setTransform(164,-364);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.closeButton},{t:this.backButton}]}).wait(1));
	this.backButton.addEventListener("tick", AdobeAn.handleFilterCache);
	this.closeButton.addEventListener("tick", AdobeAn.handleFilterCache);

	// scrollpane
	this.conversationList = new lib.ScrollPane();
	this.conversationList.name = "conversationList";
	this.conversationList.setTransform(-198,-327);

	this.timeline.addTween(cjs.Tween.get(this.conversationList).wait(1));

	// screenDimensions
	this.screenDimensions = new lib.SmartphoneScreenDimensions();
	this.screenDimensions.name = "screenDimensions";
	this.screenDimensions.setTransform(0,0.5);

	this.timeline.addTween(cjs.Tween.get(this.screenDimensions).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SmartphoneEmailConversationScreenSkin, new cjs.Rectangle(-209.2,-408.5,441.9,817), null);


(lib.SmartphoneEmailConversationListScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// applicationTitleTextField
	this.applicationTitleTextField = new cjs.Text("Inbox", "24px 'Open Sans'", "#534741");
	this.applicationTitleTextField.name = "applicationTitleTextField";
	this.applicationTitleTextField.lineHeight = 35;
	this.applicationTitleTextField.lineWidth = 210;
	this.applicationTitleTextField.parent = this;
	this.applicationTitleTextField.setTransform(-61.95,-382.7);
ranj.TextOffsetFixer.fix(this.applicationTitleTextField);

	this.timeline.addTween(cjs.Tween.get(this.applicationTitleTextField).wait(1));

	// topBarIcon
	this.topBarIcon = new lib.InboxIcon_1();
	this.topBarIcon.name = "topBarIcon";
	this.topBarIcon.setTransform(-81,-365);
	var topBarIconFilter_1 = new cjs.ColorFilter(0,0,0,1,83,71,65,0);
	this.topBarIcon.filters = [topBarIconFilter_1];
	this.topBarIcon.cache(-15,-14,29,28);

	this.timeline.addTween(cjs.Tween.get(this.topBarIcon).wait(1));
	this.timeline.addTween(cjs.Tween.get(topBarIconFilter_1).wait(1));

	// topBarNavButtons
	this.backButton = new lib.TopBarBackButton();
	this.backButton.name = "backButton";
	this.backButton.setTransform(-167,-364);

	this.closeButton = new lib.TopBarCloseWindowButton();
	this.closeButton.name = "closeButton";
	this.closeButton.setTransform(164,-364);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.closeButton},{t:this.backButton}]}).wait(1));
	this.backButton.addEventListener("tick", AdobeAn.handleFilterCache);
	this.closeButton.addEventListener("tick", AdobeAn.handleFilterCache);

	// scrollBar
	this.conversationList = new lib.ScrollPaneInbox2();
	this.conversationList.name = "conversationList";
	this.conversationList.setTransform(-198,-332.5);

	this.timeline.addTween(cjs.Tween.get(this.conversationList).wait(1));

	// screenDimensions
	this.screenDimensions = new lib.SmartphoneScreenDimensions();
	this.screenDimensions.name = "screenDimensions";
	this.screenDimensions.setTransform(0,0.5);

	this.timeline.addTween(cjs.Tween.get(this.screenDimensions).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SmartphoneEmailConversationListScreenSkin, new cjs.Rectangle(-199,-408.5,426,817), null);


(lib.SmartphoneChatContactsScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// topBarIcon
	this.topBarIcon = new lib.ContactsIco();
	this.topBarIcon.name = "topBarIcon";
	this.topBarIcon.setTransform(-73,-365);

	this.timeline.addTween(cjs.Tween.get(this.topBarIcon).wait(1));

	// applicationTitleTextField
	this.applicationTitleTextField = new cjs.Text("Contacts", "24px 'Open Sans'", "#EBEAEA");
	this.applicationTitleTextField.name = "applicationTitleTextField";
	this.applicationTitleTextField.lineHeight = 35;
	this.applicationTitleTextField.lineWidth = 202;
	this.applicationTitleTextField.parent = this;
	this.applicationTitleTextField.setTransform(-54,-382.7);
ranj.TextOffsetFixer.fix(this.applicationTitleTextField);

	this.timeline.addTween(cjs.Tween.get(this.applicationTitleTextField).wait(1));

	// scrollBar
	this.scrollBar = new lib.VScrollBarContactList();
	this.scrollBar.name = "scrollBar";
	this.scrollBar.setTransform(184.5,-329.1);

	this.timeline.addTween(cjs.Tween.get(this.scrollBar).wait(1));

	// scrollPane
	this.scrollPane = new lib.ScrollPaneContacts();
	this.scrollPane.name = "scrollPane";
	this.scrollPane.setTransform(-198,-332.5);

	this.timeline.addTween(cjs.Tween.get(this.scrollPane).wait(1));

	// topBarNavButtons
	this.closeButton = new lib.TopBarCloseWindowWhiteButton();
	this.closeButton.name = "closeButton";
	this.closeButton.setTransform(164,-364);

	this.timeline.addTween(cjs.Tween.get(this.closeButton).wait(1));

	// bg
	this.instance = new lib.BGDarkGrey();
	this.instance.setTransform(-199,-409);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SmartphoneChatContactsScreenSkin, new cjs.Rectangle(-199,-409,398,817), null);


(lib.EmailBoxSelectionComponent = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.outboxButton = new lib.SentButton();
	this.outboxButton.name = "outboxButton";
	this.outboxButton.setTransform(198,143);

	this.draftsButton = new lib.DraftsButton();
	this.draftsButton.name = "draftsButton";
	this.draftsButton.setTransform(198,84);

	this.inboxButton = new lib.EmailBoxButton();
	this.inboxButton.name = "inboxButton";
	this.inboxButton.setTransform(198,25);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.inboxButton},{t:this.draftsButton},{t:this.outboxButton}]}).wait(1));
	this.outboxButton.addEventListener("tick", AdobeAn.handleFilterCache);
	this.draftsButton.addEventListener("tick", AdobeAn.handleFilterCache);
	this.inboxButton.addEventListener("tick", AdobeAn.handleFilterCache);

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EmailBoxSelectionComponent, new cjs.Rectangle(0,0,396,168), null);


(lib.SmartphoneCloseButton_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// hitArea
	this.hitArea = new lib.RoundEmpty();
	this.hitArea.name = "hitArea";
	this.hitArea.setTransform(0,0,1.2667,0.9);

	this.timeline.addTween(cjs.Tween.get(this.hitArea).wait(4));

	// Layer_3
	this.instance = new lib.SmarthphoneCloseButtonAnim();
	this.instance.setTransform(-0.5,-4.5);

	this.instance_1 = new lib.SmartphoneCloseButon2Base();
	this.instance_1.setTransform(-0.5,-4.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1,p:{y:-4.5}}]},1).to({state:[{t:this.instance_1,p:{y:0.5}}]},1).to({state:[]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-53,-51,113,113);


(lib.ChatOptionsPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// sendButton
	this.sendButton = new lib.RoundSendButton();
	this.sendButton.name = "sendButton";
	this.sendButton.setTransform(170.5,-60.65);

	this.timeline.addTween(cjs.Tween.get(this.sendButton).wait(1));

	// options
	this.option4 = new lib.ChatOptionButton();
	this.option4.name = "option4";
	this.option4.setTransform(-1.5,131.65);

	this.option3 = new lib.ChatOptionButton();
	this.option3.name = "option3";
	this.option3.setTransform(-1.5,89.4);

	this.option2 = new lib.ChatOptionButton();
	this.option2.name = "option2";
	this.option2.setTransform(-1.5,47.25);

	this.option1 = new lib.ChatOptionButton();
	this.option1.name = "option1";
	this.option1.setTransform(-1.5,5.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.option1},{t:this.option2},{t:this.option3},{t:this.option4}]}).wait(1));

	// input
	this.input = new lib.ChatInputField();
	this.input.name = "input";
	this.input.setTransform(-184.5,-100);

	this.timeline.addTween(cjs.Tween.get(this.input).wait(1));

	// pieletje
	this.pieletje = new lib.ChatReplyOptionsPieletje_1();
	this.pieletje.name = "pieletje";
	this.pieletje.setTransform(0,-14);

	this.timeline.addTween(cjs.Tween.get(this.pieletje).wait(1));

	// bg
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(0,0,0,0)").ss(1,1,1).p("A+713MA93AAAMAAAArvMg93AAAg");
	this.shape.setTransform(0,35.55);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#CCCCCC").s().p("A+7V4MAAAgrvMA93AAAMAAAArvg");
	this.shape_1.setTransform(0,35.55);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ChatOptionsPanel, new cjs.Rectangle(-199,-105.4,398,282), null);


(lib.EmailDraftOptionOverlayOptionButtonSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// disabled
	this.disabled = new lib.EmailDraftButton9SliceDisabled();
	this.disabled.name = "disabled";

	this.timeline.addTween(cjs.Tween.get(this.disabled).wait(4));
	this.disabled.addEventListener("tick", AdobeAn.handleFilterCache);

	// down
	this.down = new lib.EmailDraftButton9SliceDown();
	this.down.name = "down";

	this.timeline.addTween(cjs.Tween.get(this.down).wait(4));

	// over
	this.over = new lib.EmailDraftButton9SlideOver();
	this.over.name = "over";

	this.timeline.addTween(cjs.Tween.get(this.over).wait(4));
	this.over.addEventListener("tick", AdobeAn.handleFilterCache);

	// up
	this.up = new lib.EmailDraftButton9SlideUp();
	this.up.name = "up";

	this.timeline.addTween(cjs.Tween.get(this.up).wait(4));
	this.up.addEventListener("tick", AdobeAn.handleFilterCache);

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-183,-30,367,52);


(lib.EmailDraftInputComponentSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// disabled
	this.disabled = new lib.EmailDraftInputButtonDisabled();
	this.disabled.name = "disabled";
	this.disabled.setTransform(166.5,57,1,1,0,0,0,166.5,57);

	this.timeline.addTween(cjs.Tween.get(this.disabled).wait(1));

	// down
	this.down = new lib.EmailDraftInputButtonDown();
	this.down.name = "down";
	this.down.setTransform(166.5,57,1,1,0,0,0,166.5,57);

	this.timeline.addTween(cjs.Tween.get(this.down).wait(1));

	// over
	this.over = new lib.EmailDraftInputButtonOver();
	this.over.name = "over";
	this.over.setTransform(166.5,57,1,1,0,0,0,166.5,57);

	this.timeline.addTween(cjs.Tween.get(this.over).wait(1));

	// up
	this.up = new lib.EmailDraftInputButtonUp();
	this.up.name = "up";
	this.up.setTransform(166.5,57,1,1,0,0,0,166.5,57);

	this.timeline.addTween(cjs.Tween.get(this.up).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EmailDraftInputComponentSkin, new cjs.Rectangle(-18,0,335,116), null);


(lib.SmartphoneEmailBoxSelectionScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// applicationTitleTextField
	this.applicationTitleTextField = new cjs.Text("Mailboxes", "24px 'Open Sans'", "#534741");
	this.applicationTitleTextField.name = "applicationTitleTextField";
	this.applicationTitleTextField.textAlign = "center";
	this.applicationTitleTextField.lineHeight = 35;
	this.applicationTitleTextField.lineWidth = 297;
	this.applicationTitleTextField.parent = this;
	this.applicationTitleTextField.setTransform(-0.45,-382.7);
ranj.TextOffsetFixer.fix(this.applicationTitleTextField);

	this.timeline.addTween(cjs.Tween.get(this.applicationTitleTextField).wait(1));

	// topBarNavButtons
	this.closeButton = new lib.TopBarCloseWindowButton();
	this.closeButton.name = "closeButton";
	this.closeButton.setTransform(164,-364);

	this.timeline.addTween(cjs.Tween.get(this.closeButton).wait(1));
	this.closeButton.addEventListener("tick", AdobeAn.handleFilterCache);

	// draftsButton_copy
	this.boxButtons = new lib.EmailBoxSelectionComponent();
	this.boxButtons.name = "boxButtons";
	this.boxButtons.setTransform(0,-245.15,1,1,0,0,0,198,84);

	this.timeline.addTween(cjs.Tween.get(this.boxButtons).wait(1));

	// screenDimensions
	this.screenDimensions = new lib.SmartphoneScreenDimensions();
	this.screenDimensions.name = "screenDimensions";
	this.screenDimensions.setTransform(0,0.5);

	this.timeline.addTween(cjs.Tween.get(this.screenDimensions).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SmartphoneEmailBoxSelectionScreenSkin, new cjs.Rectangle(-199,-408.5,398,817), null);


(lib.SmartphoneDeviceSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// closeButton
	this.closeButton = new lib.SmartphoneCloseButton_1();
	this.closeButton.name = "closeButton";
	this.closeButton.setTransform(0,464);

	this.timeline.addTween(cjs.Tween.get(this.closeButton).wait(1));

	// screenDimensions
	this.screenCanvas = new lib.SmartphoneScreenDimensions();
	this.screenCanvas.name = "screenCanvas";
	this.screenCanvas.alpha = 0.0117;

	this.timeline.addTween(cjs.Tween.get(this.screenCanvas).wait(1));

	// phoneFrame
	this.phoneFrame = new lib.SmartphoneFrame();
	this.phoneFrame.name = "phoneFrame";
	this.phoneFrame.setTransform(5,-3.5);

	this.timeline.addTween(cjs.Tween.get(this.phoneFrame).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SmartphoneDeviceSkin, new cjs.Rectangle(-961,-541,1922,1201.6), null);


(lib.SmartphoneChatScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// topBarNavButtons
	this.closeButton = new lib.TopBarCloseWindowWhiteButton();
	this.closeButton.name = "closeButton";
	this.closeButton.setTransform(164,-364);

	this.timeline.addTween(cjs.Tween.get(this.closeButton).wait(1));

	// backButton
	this.backButton = new lib.TopBarWhiteBackButto();
	this.backButton.name = "backButton";
	this.backButton.setTransform(-167,-364);

	this.timeline.addTween(cjs.Tween.get(this.backButton).wait(1));

	// topInfo
	this.topInfo = new lib.ChatTopInfo();
	this.topInfo.name = "topInfo";
	this.topInfo.setTransform(20.8,-365.75,1,1,0,0,0,184.8,32.2);

	this.timeline.addTween(cjs.Tween.get(this.topInfo).wait(1));

	// optionsPanelMask (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.p("EgYmA5KQioAAh2h6Qh3h7AAisMAAAhryMA93AAAMAAABryQAACsh3B7Qh2B6ioAAg");
	mask.setTransform(1,42.775);

	// options
	this.optionsPanel = new lib.ChatOptionsPanel();
	this.optionsPanel.name = "optionsPanel";
	this.optionsPanel.setTransform(0.95,245);

	var maskedShapeInstanceList = [this.optionsPanel];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.optionsPanel).wait(1));

	// scrollBar
	this.scrollBar = new lib.VScrollBarChat();
	this.scrollBar.name = "scrollBar";
	this.scrollBar.setTransform(187,-322.95);

	this.timeline.addTween(cjs.Tween.get(this.scrollBar).wait(1));

	// scrollPane
	this.scrollPane = new lib.ChatScrollPane();
	this.scrollPane.name = "scrollPane";
	this.scrollPane.setTransform(1,47,1,1,0,0,0,198,370);

	this.timeline.addTween(cjs.Tween.get(this.scrollPane).wait(1));

	// screenDimensions
	this.screenDimensions = new lib.SmartphoneBrandedScreenDimensions();
	this.screenDimensions.name = "screenDimensions";
	this.screenDimensions.setTransform(0,0.5);

	this.timeline.addTween(cjs.Tween.get(this.screenDimensions).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SmartphoneChatScreenSkin, new cjs.Rectangle(-209.2,-407.5,441.9,817), null);


// stage content:
(lib.SmartphoneAssets = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,0,0);
// library properties:
lib.properties = {
	id: 'CF364FABBE3675439F965DE3116F7378',
	width: 1920,
	height: 1080,
	fps: 60,
	color: "#333333",
	opacity: 1.00,
	manifest: [
		{src:"assets/skins/images/SmartphoneAssets/BackButtonIcon.png", id:"SmartphoneAssets_BackButtonIcon", bundle:"SmartphoneAssets"},
		{src:"assets/skins/images/SmartphoneAssets/BackButtonSmallIcon.png", id:"SmartphoneAssets_BackButtonSmallIcon", bundle:"SmartphoneAssets"},
		{src:"assets/skins/images/SmartphoneAssets/BG.png", id:"SmartphoneAssets_BG", bundle:"SmartphoneAssets"},
		{src:"assets/skins/images/SmartphoneAssets/BGB1.png", id:"SmartphoneAssets_BGB1", bundle:"SmartphoneAssets"},
		{src:"assets/skins/images/SmartphoneAssets/BGDarkGrey.png", id:"SmartphoneAssets_BGDarkGrey", bundle:"SmartphoneAssets"},
		{src:"assets/skins/images/SmartphoneAssets/ChatConfirmButtonDisabled.png", id:"SmartphoneAssets_ChatConfirmButtonDisabled", bundle:"SmartphoneAssets"},
		{src:"assets/skins/images/SmartphoneAssets/ChatConfirmButtonUp.png", id:"SmartphoneAssets_ChatConfirmButtonUp", bundle:"SmartphoneAssets"},
		{src:"assets/skins/images/SmartphoneAssets/ChatIcon.png", id:"SmartphoneAssets_ChatIcon", bundle:"SmartphoneAssets"},
		{src:"assets/skins/images/SmartphoneAssets/ChatNPCBalloon2.png", id:"SmartphoneAssets_ChatNPCBalloon2", bundle:"SmartphoneAssets"},
		{src:"assets/skins/images/SmartphoneAssets/ChatOfflineIndicator.png", id:"SmartphoneAssets_ChatOfflineIndicator", bundle:"SmartphoneAssets"},
		{src:"assets/skins/images/SmartphoneAssets/ChatOnlineIndicator.png", id:"SmartphoneAssets_ChatOnlineIndicator", bundle:"SmartphoneAssets"},
		{src:"assets/skins/images/SmartphoneAssets/ChatPlayerBalloonBG.png", id:"SmartphoneAssets_ChatPlayerBalloonBG", bundle:"SmartphoneAssets"},
		{src:"assets/skins/images/SmartphoneAssets/ChatReplyOptionButtonDisabled.png", id:"SmartphoneAssets_ChatReplyOptionButtonDisabled", bundle:"SmartphoneAssets"},
		{src:"assets/skins/images/SmartphoneAssets/ChatReplyOptionButtonHi.png", id:"SmartphoneAssets_ChatReplyOptionButtonHi", bundle:"SmartphoneAssets"},
		{src:"assets/skins/images/SmartphoneAssets/ChatReplyOptionButtonUp.png", id:"SmartphoneAssets_ChatReplyOptionButtonUp", bundle:"SmartphoneAssets"},
		{src:"assets/skins/images/SmartphoneAssets/ChatReplyOptionsPieletje.png", id:"SmartphoneAssets_ChatReplyOptionsPieletje", bundle:"SmartphoneAssets"},
		{src:"assets/skins/images/SmartphoneAssets/ChatReplyPreviewFieldBG.png", id:"SmartphoneAssets_ChatReplyPreviewFieldBG", bundle:"SmartphoneAssets"},
		{src:"assets/skins/images/SmartphoneAssets/ChoiceButtonDisabled.png", id:"SmartphoneAssets_ChoiceButtonDisabled", bundle:"SmartphoneAssets"},
		{src:"assets/skins/images/SmartphoneAssets/ChoiceButtonHi.png", id:"SmartphoneAssets_ChoiceButtonHi", bundle:"SmartphoneAssets"},
		{src:"assets/skins/images/SmartphoneAssets/ChoiceButtonUp.png", id:"SmartphoneAssets_ChoiceButtonUp", bundle:"SmartphoneAssets"},
		{src:"assets/skins/images/SmartphoneAssets/ChoiceIndicator.png", id:"SmartphoneAssets_ChoiceIndicator", bundle:"SmartphoneAssets"},
		{src:"assets/skins/images/SmartphoneAssets/CloseButtonIcon.png", id:"SmartphoneAssets_CloseButtonIcon", bundle:"SmartphoneAssets"},
		{src:"assets/skins/images/SmartphoneAssets/ContactsIcon.png", id:"SmartphoneAssets_ContactsIcon", bundle:"SmartphoneAssets"},
		{src:"assets/skins/images/SmartphoneAssets/DraftBG.png", id:"SmartphoneAssets_DraftBG", bundle:"SmartphoneAssets"},
		{src:"assets/skins/images/SmartphoneAssets/DraftsIcon.png", id:"SmartphoneAssets_DraftsIcon", bundle:"SmartphoneAssets"},
		{src:"assets/skins/images/SmartphoneAssets/DropdownIcon.png", id:"SmartphoneAssets_DropdownIcon", bundle:"SmartphoneAssets"},
		{src:"assets/skins/images/SmartphoneAssets/EditIconDisabled.png", id:"SmartphoneAssets_EditIconDisabled", bundle:"SmartphoneAssets"},
		{src:"assets/skins/images/SmartphoneAssets/EditIconUp.png", id:"SmartphoneAssets_EditIconUp", bundle:"SmartphoneAssets"},
		{src:"assets/skins/images/SmartphoneAssets/EmailDraftInputButtonBackground.png", id:"SmartphoneAssets_EmailDraftInputButtonBackground", bundle:"SmartphoneAssets"},
		{src:"assets/skins/images/SmartphoneAssets/EmailReceivedBackground.png", id:"SmartphoneAssets_EmailReceivedBackground", bundle:"SmartphoneAssets"},
		{src:"assets/skins/images/SmartphoneAssets/EmptyThumb.png", id:"SmartphoneAssets_EmptyThumb", bundle:"SmartphoneAssets"},
		{src:"assets/skins/images/SmartphoneAssets/EmptyThumbBig.png", id:"SmartphoneAssets_EmptyThumbBig", bundle:"SmartphoneAssets"},
		{src:"assets/skins/images/SmartphoneAssets/GroupChatNPCBalloon2.png", id:"SmartphoneAssets_GroupChatNPCBalloon2", bundle:"SmartphoneAssets"},
		{src:"assets/skins/images/SmartphoneAssets/InboxIcon.png", id:"SmartphoneAssets_InboxIcon", bundle:"SmartphoneAssets"},
		{src:"assets/skins/images/SmartphoneAssets/MailIcon.png", id:"SmartphoneAssets_MailIcon", bundle:"SmartphoneAssets"},
		{src:"assets/skins/images/SmartphoneAssets/ModalButtonBG.png", id:"SmartphoneAssets_ModalButtonBG", bundle:"SmartphoneAssets"},
		{src:"assets/skins/images/SmartphoneAssets/ModalButtonDown.png", id:"SmartphoneAssets_ModalButtonDown", bundle:"SmartphoneAssets"},
		{src:"assets/skins/images/SmartphoneAssets/NewIndicatorLarge.png", id:"SmartphoneAssets_NewIndicatorLarge", bundle:"SmartphoneAssets"},
		{src:"assets/skins/images/SmartphoneAssets/OfflineIndicator.png", id:"SmartphoneAssets_OfflineIndicator", bundle:"SmartphoneAssets"},
		{src:"assets/skins/images/SmartphoneAssets/OnlineIndicator.png", id:"SmartphoneAssets_OnlineIndicator", bundle:"SmartphoneAssets"},
		{src:"assets/skins/images/SmartphoneAssets/PhoneBG.png", id:"SmartphoneAssets_PhoneBG", bundle:"SmartphoneAssets"},
		{src:"assets/skins/images/SmartphoneAssets/PhoneBG_dummy.png", id:"SmartphoneAssets_PhoneBG_dummy", bundle:"SmartphoneAssets"},
		{src:"assets/skins/images/SmartphoneAssets/RedPill.png", id:"SmartphoneAssets_RedPill", bundle:"SmartphoneAssets"},
		{src:"assets/skins/images/SmartphoneAssets/ReplyIcon.png", id:"SmartphoneAssets_ReplyIcon", bundle:"SmartphoneAssets"},
		{src:"assets/skins/images/SmartphoneAssets/SendButtonDisabled.png", id:"SmartphoneAssets_SendButtonDisabled", bundle:"SmartphoneAssets"},
		{src:"assets/skins/images/SmartphoneAssets/SendButtonUp.png", id:"SmartphoneAssets_SendButtonUp", bundle:"SmartphoneAssets"},
		{src:"assets/skins/images/SmartphoneAssets/SentIcon.png", id:"SmartphoneAssets_SentIcon", bundle:"SmartphoneAssets"},
		{src:"assets/skins/images/SmartphoneAssets/SmartphoneCloseButton.png", id:"SmartphoneAssets_SmartphoneCloseButton", bundle:"SmartphoneAssets"},
		{src:"assets/skins/images/SmartphoneAssets/SmartphoneEmailIndicatorButtonBackground.png", id:"SmartphoneAssets_SmartphoneEmailIndicatorButtonBackground", bundle:"SmartphoneAssets"},
		{src:"assets/skins/images/SmartphoneAssets/SmartphoneHand.png", id:"SmartphoneAssets_SmartphoneHand", bundle:"SmartphoneAssets"},
		{src:"assets/skins/images/SmartphoneAssets/VinkjeIcon.png", id:"SmartphoneAssets_VinkjeIcon", bundle:"SmartphoneAssets"},
		{src:"assets/skins/images/SmartphoneAssets/WhiteBar.png", id:"SmartphoneAssets_WhiteBar", bundle:"SmartphoneAssets"}
	],
	preloads: []
};



an.handleFilterCache = function(event) {
	if(!event.paused){
		var target = event.target;
		if(target){
			if(target.filterCacheList){
				for(var index = 0; index < target.filterCacheList.length ; index++){
					var cacheInst = target.filterCacheList[index];
					if((cacheInst.startFrame <= target.currentFrame) && (target.currentFrame <= cacheInst.endFrame)){
						cacheInst.instance.cache(cacheInst.x, cacheInst.y, cacheInst.w, cacheInst.h);
					}
				}
			}
		}
	}
}


})(lib.SmartphoneAssets = {}, images, ss, createjs, AdobeAn = AdobeAn||{});
var AdobeAn;
module.exports = lib.SmartphoneAssets;